import { render, staticRenderFns } from "./modalSimple.vue?vue&type=template&id=bcdc3d7a"
import script from "./modalSimple.vue?vue&type=script&lang=js"
export * from "./modalSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports